import { Colors, Services } from '@sigma-frontend-libs/commons'

import flag from '@/components/flag'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderFlag(h) {
  return h(
    flag,
    {
      props: {
        value: this.value.countryCode,
        squircle: true
      }
    }
  )
}
function renderClientIp(h) {
  if (this.viewport.size.width > 480) {
    return h(
      sticker,
      {
        props: {
          value: this.value.clientIp,
          label: this.getTranslate(`${Services['url-shortener-tracking']}.labels.clientIp`),
          color: Colors.grey,
          copy: true,
          maxWidth: 250
        },
        scopedSlots: {
          icon: () => {
            return renderFlag.call(this, h)
          }
        }
      }
    )
  }
}
function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'service-template-item cursor--pointer',
      on: {
        click: this.clickHandler
      }
    },
    [
      renderClientIp.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
